module.exports = __webpack_public_path__ + "img/babybook-chevron-blue.ac352e9c.svg";